const PLANS = [
    {
        name: "The Seasonal",
        cadence: "Every 3 months",
        price: "£42",
        perks: ["1 signature candle", "Seasonal scent curation", "Free shipping"],
    },
    {
        name: "The Monthly",
        cadence: "Every month",
        price: "£38",
        perks: ["1 signature candle", "Early access to new scents", "Free shipping", "10% off all orders"],
    },
    {
        name: "The Collector",
        cadence: "Every month",
        price: "£68",
        perks: ["2 signature candles", "Exclusive subscriber scents", "Free shipping", "15% off all orders", "Handwritten note"],
    },
];

export function SubscriptionOptions() {
    return (
        <section className="max-w-7xl mx-auto px-6 py-24">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {PLANS.map((plan) => (
                    <div key={plan.name} className="border border-stone-200 p-10 flex flex-col gap-6">
                        <div>
                            <p className="uppercase tracking-[0.2em] text-xs text-stone-400 mb-2">{plan.cadence}</p>
                            <h3 className="font-serif text-2xl font-light italic">{plan.name}</h3>
                            <p className="text-3xl font-light mt-4">{plan.price}<span className="text-sm text-stone-400"> / delivery</span></p>
                        </div>
                        <ul className="space-y-3 text-sm text-stone-600 font-light flex-1">
                            {plan.perks.map((perk) => (
                                <li key={perk} className="flex items-center gap-2">
                                    <span className="w-1 h-1 rounded-full bg-stone-400 shrink-0" />
                                    {perk}
                                </li>
                            ))}
                        </ul>
                        <button className="w-full border border-stone-900 py-3 text-sm uppercase tracking-widest hover:bg-stone-900 hover:text-white transition-colors">
                            Subscribe
                        </button>
                    </div>
                ))}
            </div>
        </section>
    );
}
